import React, { useEffect, useState } from 'react';
import './index.scss';
import Select from '@/components/common/select';

const DateSelect = ({ value, onChange, disabled = false, ...props }) => {
  const dt = value ? new Date(value) : new Date();
  const month = dt.getMonth() + 1;
  const year = dt.getFullYear();
  const [dates, setDates] = useState(getDateInMonth(month, year));
  const [data, setData] = useState({ date: dt.getDate(), month, year });

  useEffect(() => {
    if (value) {
      const date = new Date(value);
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      setData({ date: dt.getDate(), month, year });
    }
  }, [value]);

  useEffect(() => {
    setDates(getDateInMonth(data.month, data.year));
  }, [data.month, data.year]);

  useEffect(() => {
    onChange?.(new Date(data.year, data.month - 1, data.date));
  }, [data]);

  useEffect(() => {
    if (!dates.find((_) => _.value === data.date))
      setData(({ month, year }) => ({ date: dates[0].value, month, year }));
  }, [dates.length]);

  return (
    <span className="date-input inputs" {...props}>
      <Select
        value={data.date}
        defaultText="DD"
        options={dates}
        onChange={(date) => setData(({ month, year }) => ({ date, month, year }))}
        disabled={disabled}
      />
      <Select
        value={data.month}
        defaultText="MM"
        options={MONTHS}
        onChange={(month) => setData(({ date, year }) => ({ date, month, year }))}
        disabled={disabled}
      />
      <Select
        value={data.year}
        defaultText="YYYY"
        options={YEARS}
        onChange={(year) => setData(({ date, month }) => ({ date, month, year }))}
        disabled={disabled}
      />
    </span>
  );
};

export default DateSelect;

const getDateInMonth = (month, year) => {
  return Array.from({ length: new Date(year, month, 0).getDate() }, (v, i) => ({
    value: i + 1,
    label: i + 1,
  }));
};

const getYears = (back) => {
  const year = new Date().getFullYear();
  return Array.from({ length: back }, (v, i) => year - back + i + 1);
};
const YEARS = getYears(100)
  .reverse()
  .map((_) => ({ value: _, label: _ }));

const MONTHS = [...Array(12).keys()]
  .map((key) => new Date(0, key).toLocaleString('en', { month: 'long' }))
  .map((_, i) => ({ value: i + 1, label: i + 1 }));
